export const Roles = {
  superAdmin: "super_admin",
  admin: "admin",
  operator: "operator",
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];

export const RoleLabels: Record<Role, string> = {
  [Roles.superAdmin]: "Super Admin",
  [Roles.admin]: "Admin",
  [Roles.operator]: "Operator",
};

export function normalizeRole(role?: string | null): Role | undefined {
  if (!role) return undefined;

  const normalized = role.trim().toLowerCase().replace(/[\s_-]/g, "");

  if (normalized === "superadmin") return Roles.superAdmin;
  if (normalized === "admin") return Roles.admin;
  if (normalized === "operator") return Roles.operator;

  return undefined;
}

export function isSuperAdmin(role?: string | null): boolean {
  return normalizeRole(role) === Roles.superAdmin;
}

export function isAdmin(role?: string | null): boolean {
  return normalizeRole(role) === Roles.admin;
}

export function isOperator(role?: string | null): boolean {
  return normalizeRole(role) === Roles.operator;
}

export function isAdminLike(role?: string | null): boolean {
  const normalizedRole = normalizeRole(role);
  return normalizedRole === Roles.superAdmin || normalizedRole === Roles.admin;
}
